import type {
    ActorEvent,
    Field,
    HighLightConditions,
    RecordLikeProtocol,
    RecordOperatorProtocol,
    RichTextContentProtocol,
    TableViewOptions,
    ViewField
} from '@lighthouse/core'
import { useApplicationContext } from '@lighthouse/shared'
import React from 'react'

import { ListContent } from './ListContent'

interface ListProps {
    eventList?: ActorEvent[]
    checkable?: boolean
    primaryField?: Field
    viewFields: ViewField[]
    selectedRecords?: string[]
    highLightRules?: HighLightConditions
    designConfig: TableViewOptions
    recordOperator?: RecordOperatorProtocol['recordOperator']
    onRecordSelect?: (recordIds: string[]) => void
    onRecordOperatorActionTrigger?: (id: string, actorEvent: ActorEvent, record?: RecordLikeProtocol) => Promise<void>
    onRecordClick?: (id: string, actorEvent: ActorEvent, record: RecordLikeProtocol) => Promise<void>
    onRenderButtonTitle: (v: RichTextContentProtocol, record?: RecordLikeProtocol) => string
}

export const List: React.FC<ListProps> = ({
    eventList,
    checkable,
    primaryField,
    viewFields,
    selectedRecords,
    highLightRules,
    designConfig,
    recordOperator,
    onRecordSelect,
    onRecordOperatorActionTrigger,
    onRecordClick,
    onRenderButtonTitle
}) => {
    const { isMobile } = useApplicationContext()
    return (
        <ListContent
            eventList={eventList}
            checkable={checkable}
            primaryField={primaryField}
            viewFields={viewFields}
            isMobile={isMobile}
            selectedRecords={selectedRecords}
            highLightRules={highLightRules}
            designConfig={designConfig}
            recordOperator={recordOperator}
            onRecordSelect={onRecordSelect}
            onRecordOperatorActionTrigger={onRecordOperatorActionTrigger}
            onRecordClick={onRecordClick}
            onRenderButtonTitle={onRenderButtonTitle}
        />
    )
}
